define('casino/providers/PlayNGo',['jquery', 'all/player/playerinfo'], function ($, playerinfo) {
	'use strict';

	function PlayNGo(casino, gameFunctions) {
		if (!(this instanceof PlayNGo)) {
			throw new TypeError('PlayNGo constructor cannot be called as a function.');
		}

		this.casino = casino;
		this.gameFunctions = gameFunctions;
	}

	function freeMode(playNGo, game, options) {
		playNGo.gameFunctions.showHelpButton();
		var provider = playNGo.casino.getProvider(game);
		var src = provider.url;

		var splitIdAndCode = game.code.split('_');
		if (splitIdAndCode[0] !== 'PNG') {
			throw new Error('Illegal game code not starting with PNG: ' + game.code);
		}

		var pid = provider.siteId;
		var code = splitIdAndCode[splitIdAndCode.length - 1];

		var $gameHolder = options.gameHolder;

		var $game = $gameHolder.find('.game');
		$game.empty();

		var width = $game.data('width');
		var height = $game.data('height');

		src += $.param({
			div: 'loaded-game-' + $gameHolder.index(),
			gid: code,
			lang: game.language,
			username: 'practice',
			pid: pid,
			demo: 2,
			width: width,
			height: height,
			wmode: 'direct',
			practice: 1,
			brand: provider.brand
		});

		window.Logout = function () {
			window.location = playNGo.casino.lastSelectedLobbyTab;
		};

		window.ShowCashier = function () {
			//TODO: redirect to login?
		};

		window.reloadgame = function(gameId, user) {
			window.location.reload();
		};

		playNGo.gameFunctions.switchToFreeMode(game, {
			gameHolder: options.gameHolder,
			type: 'script',
			src: src
		});
	}

	function realMode(playNGo, game, options, data) {
		playNGo.gameFunctions.showHelpButton();
		var provider = playNGo.casino.getProvider(game);
		var src = provider.url;

		var splitIdAndCode = game.code.split('_');
		if (splitIdAndCode[0] !== 'PNG') {
			throw new Error('Illegal game code not starting with PNG: ' + game.code);
		}

		var pid = provider.siteId;
		var code = splitIdAndCode[2];

		var $gameHolder = options.gameHolder;

		var $game = $gameHolder.find('.game');
		$game.empty();

		var width = $game.data('width');
		var height = $game.data('height');

		if (playNGo.casino.getLocation() === 'GB') {
			src += $.param({
				div: 'loaded-game-' + $gameHolder.index(),
				gid: code,
				lang: game.language,
				username: data.sessionId,
				pid: pid,
				width: width,
				height: height,
				wmode: 'direct',
				practice: 0,
				autoplaylimits: 1,
				autoplayreset: 1,
				brand: provider.brand
			});
		}
		else {
			src += $.param({
				div: 'loaded-game-' + $gameHolder.index(),
				gid: code,
				lang: game.language,
				username: data.sessionId,
				pid: pid,
				width: width,
				height: height,
				wmode: 'direct',
				practice: 0,
				brand: provider.brand
			});
		}
		window.Logout = function () {
			window.location = playNGo.casino.lastSelectedLobbyTab;
		};

		window.reloadgame = function(gameId, user) {
			window.location.reload();
		};


		window.ShowCashier = function () {
			playerinfo.openDeposit();
		};

		playNGo.gameFunctions.switchToRealMode(game, {
			gameHolder: options.gameHolder,
			type: 'script',
			src: src
		});
		playNGo.gameFunctions.verifyCurrency(data.currency);
	}

	PlayNGo.prototype = {
		constructor: PlayNGo,
		freeMode: function (game, options) {
			freeMode(this, game, options);
		},
		realMode: function (game, options, data) {
			realMode(this, game, options, data);
		}
	};
	return PlayNGo;
});

